import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { debounceTime, Subject } from 'rxjs';
import { LogoLibraryResponse } from 'src/app/core/interfaces/logoLibraryResponse';

@Component({
    selector: 'app-select-search',
    templateUrl: './select-search.component.html',
    styleUrls: ['./select-search.component.scss'],
    standalone: false
})
export class SelectSearchComponent implements OnInit {

  @ViewChild(MatMenuTrigger) menu: MatMenuTrigger;

  @Input("isEdit") isEdit: string;

  @Input('data') set dataSet(value: LogoLibraryResponse[]) {
    if (value) {
      this.data = value;
      this.filteredLogos = this.data
      this.allLogos = [...this.data]

      this.selectItem = this.data.find( d => d.is_default)
      if(this.selectItem && !(this.isEdit.toLowerCase().includes('edit'))){
        this.logoSelected.emit(this.selectItem);
      }
    }
  }
  get dataSet(): any {
    return this.data;
  }
  @Input('selectedItem') set selectedItemSet(value: LogoLibraryResponse) {
    if (value) {
      this.selectItem = value;
      this.logoSelected.emit(this.selectItem);
    } else {
      if(!this.selectItem){
        this.selectItem = {
          id: '',
          name: 'logo title',
          path: '',
          is_default: false
        }
      }
    }
  }

  @Input('disabled') disabled: boolean = false;

  get selectedItemSet(): any {
    return this.selectItem;
  }
  @Output() logoSelected: EventEmitter<LogoLibraryResponse> = new EventEmitter<LogoLibraryResponse>();

  constructor() { }

  debouncer: Subject<string> = new Subject();

  /** The text used to filter the logos */
  filterText: string = ""

  filteredLogos: LogoLibraryResponse[] = [];
  allLogos: LogoLibraryResponse[] = [];
  selectItem: LogoLibraryResponse;
  data: LogoLibraryResponse[] = [];

  keyPressed() {
    this.debouncer.next(this.filterText);
  }

  openMenu(): void {
    this.menu.openMenu();
  }

  menuItemClicked(clickEvent: Event, item: LogoLibraryResponse) {
    clickEvent.preventDefault()
    clickEvent.stopPropagation()
    this.selectItem = item;
    this.menu.closeMenu();
    this.logoSelected.emit(item);
  }

  refocus(focusEvent: FocusEvent) {
    setTimeout(() => {
      const inputElement = focusEvent.target as HTMLInputElement
      inputElement.focus()
    }, 20)
  }


  buildFilteredLogos(value: string) {
    this.filteredLogos = this.allLogos.filter(log => {
      return log.name.toLowerCase().includes(value.toLowerCase());
    })
    if (value == '') {
      this.filteredLogos = [...this.allLogos];
    }
  }

  clearSearchLogo(clickEvent: Event) {
    clickEvent.preventDefault()
    clickEvent.stopPropagation()
  }

  ngOnInit(): void {
    /** Debouncer waits until the user stops typing to begins the search */
    this.debouncer
      .pipe(debounceTime(300))
      .subscribe(value => {
        this.buildFilteredLogos(value);
      });
  }
}
